let targetedShadowRoot = null;

function monkeyPatchDomSearch() {
  const originalGetElementById = document.getElementById;
  const originalQuerySelector = document.querySelector;
  const originalQuerySelectorAll = document.querySelectorAll;

  document.getElementById = (id) => originalGetElementById.call(document, id) || targetedShadowRoot?.getElementById(id);
  document.querySelector = (selector) =>
    originalQuerySelector.call(document, selector) || targetedShadowRoot?.querySelector(selector);
  document.querySelectorAll = (selector) => [
    ...originalQuerySelectorAll.call(document, selector),
    ...(targetedShadowRoot ? targetedShadowRoot.querySelectorAll(selector) : []),
  ];
}

if (!customElements.get('up-listicle-container')) {
  class upListicleContainer extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachShadow({ mode: 'open' });
      const template = document.querySelector('#up-listicle-template');

      if (template) {
        const content = template.content.cloneNode(true);
        this.shadowRoot.appendChild(content);

        this.shadowRoot.addEventListener('click', this.handleAnchorScroll.bind(this));

        targetedShadowRoot = this.shadowRoot;
        monkeyPatchDomSearch();

        // Execute inline JS
        const scripts = this.shadowRoot.querySelectorAll('script');
        scripts.forEach((script) => {
          if (script.textContent) {
            const newScript = document.createElement('script');
            newScript.textContent = script.textContent;
            script.replaceWith(newScript);
          }
        });
      }
    }

    handleAnchorScroll(event) {
      const link = event.target.closest('a');
      if (!link || !link.hash || !link.hash.startsWith('#')) return;

      if (link.hash.startsWith('#')) {
        event.preventDefault();
        const targetElement = this.shadowRoot.querySelector(link.hash);
        if (!targetElement) return;
        
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    }
  }

  customElements.define('up-listicle-container', upListicleContainer);
}
